import { Chip } from '@material-ui/core';
import { StatusPointerT, ViewClientT, StatusClientT } from 'bovaljaren-models';
import { useObserver } from 'mobx-react-lite';
import React, { ReactElement, useContext } from 'react';
import { AppContext } from '../../../../../state/app.state';
import { isMobile } from '../../../../../utils/app.helper';

import './ViewLabel.scss';

type ViewLabelProps={
    statusPoint: StatusPointerT;
    view?: ViewClientT;
    previewing: boolean;
};

type StatusSummaryT = {
    singular: string;
    id: number;
    plural: string;
    type: string;
    count: number;
};

type StatusWithCountT = StatusClientT & { count: number };

const ViewLabel: React.FC<ViewLabelProps> = ({ statusPoint, view, previewing }): ReactElement => {
    const { state, filterState } = useContext(AppContext);
    const { relativePosition, hideLabel } = statusPoint;

    const style = relativePosition && { left: `${relativePosition.left - (isMobile() ? 7.5 : 0)}%`, top: `${relativePosition.top}%` };

    const getCount = (status: StatusClientT): number => {
        return filterState?.filterObjects(state?.objects, state?.project?.objectTypes)
            ?.filter(o => view?.mappings.objects.find(vMo => vMo.mappingEntityId === o.id))
            .filter(o => o.statusId === status.id)?.length || 0;
    };

    const statusSummary = state?.project?.statuses?.map((status) =>
        ({
            ...status,
            count: getCount(status)
        }));

    const filterAvailtableSummaries = (sS: StatusWithCountT): boolean => sS.type === 'available' && (state?.project?.leaseForm === 'lease' ? sS.singular === 'Tillgänglig' : sS.singular === 'Till salu');

    const filterUnAvailableSummares = (sS: StatusWithCountT): boolean => sS.type !== 'available' && sS.count !== 0;

    const getCountText = (statusSummary: StatusSummaryT): string => `${statusSummary.count} ${statusSummary.count > 1 ? statusSummary.plural : statusSummary.singular}`;

    const getCounterChip = (statusSummary: StatusSummaryT): ReactElement => <Chip key={statusSummary.id + statusSummary.type} className={`${'bv-view-label-chip bv-'}${statusSummary.type}`} label={getCountText(statusSummary)}/>;

    return useObserver(() => (
        (view && relativePosition) ? <div className='bv-view-label' style={style || undefined}>
            {!hideLabel && <p className={'bv-view-lable-title'}>{view.name}</p>}
            {statusSummary?.filter(filterAvailtableSummaries).map(getCounterChip)}
            {(previewing && !isMobile() && statusSummary?.filter(filterUnAvailableSummares).map(getCounterChip))}
        </div> : <></>
    ));
};


export default ViewLabel;